const subscriptionMessage = (event, subscribed, type = 'message') => (
  `dataset.subscriptions.${event}.${type}.${subscribed ? 'subscribed' : 'not.subscribed'}`
);

export default subscriptionMessage;
